import React, { useMemo } from 'react'
import { Card } from 'antd'
import { BarChartOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

import { currency, qtyToCurrency } from 'utils/formatting'
import { ItemRow, ItemsRow } from 'components/apps/Reports/PosShift/Detail/ItemsRow'
import SectionHeader from 'components/apps/Reports/PosShift/Detail/SectionHeader'
import HelpHint from 'components/apps/Reports/PosShift/Detail/HelpHint'
import styles from './detail.module.scss'

const RED = '#dc2626'

const SalesSummary = ({ data, loading }) => {
  const { formatMessage } = useIntl()

  const totalOmzet = useMemo(() => {
    const items = Array.isArray(data?.items) ? data.items : []
    const gross = items.reduce((s, i) => s + (Number(i?.amount) || 0), 0)
    return gross - (Number(data?.discount_total) || 0)
  }, [data])

  const taxAmount = Number(data?.tax_amount) || 0

  // Placeholder {key} di helpers dari backend diganti dengan label yang tampil di UI
  const helpers = useMemo(() => {
    const labels = {
      items: formatMessage({ id: 'report.products_sold' }),
      discount_total: formatMessage({ id: 'financePurchaseOrders.total_discount' }),
    }
    const format = (text) =>
      text ? text.replace(/\{(\w+)\}/g, (match, key) => labels[key] || match) : null

    return {
      totalOmzet: format(data?.helpers?.total_omzet),
      taxAmount: format(data?.helpers?.tax_amount),
    }
  }, [data, formatMessage])

  return (
    <Card
      className={styles.card}
      loading={loading}
      title={
        <SectionHeader
          icon={<BarChartOutlined />}
          iconClassName={styles.iconBlue}
          title={formatMessage({ id: 'report.sales_summary' })}
        />
      }
    >
      <ItemsRow>
        <ItemRow
          title={
            <span>
              {formatMessage({ id: 'report.total_omzet' })}
              {helpers.totalOmzet ? <HelpHint title={helpers.totalOmzet} /> : null}
            </span>
          }
          amount={currency(totalOmzet)}
          bold
        />
        <ItemRow
          title={formatMessage({ id: 'financePurchaseOrders.total_discount' })}
          amount={currency(data?.discount_total)}
        />
        <ItemRow
          title={formatMessage({ id: 'report.sales_transaction_completed' })}
          amount={qtyToCurrency(data?.sales_transaction)}
        />
        <ItemRow
          title={formatMessage({ id: 'report.pos_unpaid' })}
          amount={qtyToCurrency(data?.order_transaction)}
          styleTitle={{ color: RED }}
          styleAmount={{ color: RED, fontWeight: 700 }}
        />
        <ItemRow
          title={formatMessage({ id: 'report.pos_unpaid_currency' })}
          amount={currency(data?.order_amount)}
          styleTitle={{ color: RED }}
          styleAmount={{ color: RED, fontWeight: 700 }}
        />
        {taxAmount > 0 ? (
          <ItemRow
            title={
              <span>
                {formatMessage({ id: 'roles.reports_taxes' })}
                {helpers.taxAmount ? <HelpHint title={helpers.taxAmount} /> : null}
              </span>
            }
            amount={currency(taxAmount)}
          />
        ) : null}
      </ItemsRow>
    </Card>
  )
}

export default SalesSummary
